<div *ngIf="!hasSlider" class="box" [class]="'box-grid-' + actionService.actions.length" [id]="animatedBoxId">
  <div class="box-header">
    <h1 class="header1">{{ actionService.title }}</h1>
  </div>

  <!-- Fewer than 5 actions -->
  <div class="box-body" *ngIf="actionService.actions.length < 5">
    <a class="small-box"
       *ngFor="let action of actionService.actions"
       (click)="doAction(action)"
       [ngClass]="{'full-width-action': action.title === 'همیار مودی معتمد نما'}">
      <img [src]="action.img"
           alt=""
           [ngClass]="{'full-width-img': action.title === 'همیار مودی معتمد نما'}">
      <span>{{ action.title }}</span>
    </a>
  </div>

  <!-- 5 or more actions -->
  <div class="box-body" *ngIf="actionService.actions.length > 4">
    <div class="main-box">
      <!-- First 3 -->
      <a *ngFor="let action of actionService.actions | slice:0:3"
         class="small-box"
         (click)="doAction(action)"
         [ngClass]="{'full-width-action': action.title === 'همیار مودی معتمد نما'}">
        <img [src]="action.img"
             alt=""
             [ngClass]="{'full-width-img': action.title === 'همیار مودی معتمد نما'}">
        <span>{{ action.title }}</span>
      </a>

      <!-- Remaining -->
      <div class="more-box" style="position: relative;">
        <a *ngFor="let action of actionService.actions | slice:3:actionService.actions.length"
           class="inner-small-box"
           (click)="doAction(action)"
           [ngClass]="{'full-width-action': action.title === 'همیار مودی معتمد نما'}">
          <img [src]="action.img"
               alt=""
               [ngClass]="{'full-width-img': action.title === 'همیار مودی معتمد نما'}">
        </a>
        <div id="bank-disabled-box" class="disabled-box" (click)="openBankBox()"></div>
      </div>
    </div>
  </div>
</div>

<!-- Slider mode -->
<div *ngIf="hasSlider" class="box box-grid-slider">
  <div class="box-header">
    <h1 class="header1">{{ actionService.title }}</h1>
  </div>
  <div class="box-body">
    <div class="swiper-container">
      <div class="swiper-wrapper">
        <div class="swiper-slide" *ngFor="let service of actionService.actions">
          <a class="small-box"
             (click)="doAction(service)"
             [ngClass]="{'full-width-action': service.title === 'همیار مودی معتمد نما'}"
             style="width: 100%;">
            <img [src]="service.img"
                 alt=""
                 [ngClass]="{'full-width-img': service.title === 'همیار مودی معتمد نما'}">
            <span>{{ service.title }}</span>
          </a>
        </div>
      </div>
      <div class="swiper-pagination"></div>
    </div>
  </div>
</div>